import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import moment from "moment";

Font.register({
  family: "Helvetica",
  fonts: [{ src: "https://fonts.gstatic.com/s/helvetica.ttf" }],
});

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 10,
    padding: 35,
    backgroundColor: "#fff",
  },
  header: {
    marginBottom: 20,
    borderBottom: "1pt solid #ccc",
    paddingBottom: 8,
  },
  logo: { height: 50, width: 120, marginBottom: 10 },
  title: { fontSize: 14, fontWeight: "bold", marginBottom: 2,textTransform:'uppercase' },
  text: { marginBottom: 2 },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#ccc",
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 10,
  },
  tableRow: { flexDirection: "row" },
  tableHeader: {
    backgroundColor: "#db6f2f",
    fontWeight: "bold",
  },
  cellBase: {
    borderStyle: "solid",
    borderColor: "#ccc",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    textAlign: "center",
  },
  cellDate: {
    width: "25%", // Slightly wider for Day & Date
    textAlign: "left",
    paddingLeft: 8,
  },
  cellSmall: {
    width: "15%",
  },
  summary: {
    marginTop: 20,
    borderTop: "1pt solid #ccc",
    paddingTop: 8,
  },
  signatureContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 50,
    fontSize: 10,
  },
  line: {
    width: "45%",
    
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1pt solid #ddd",
    paddingVertical: 6,
    paddingHorizontal: 4,
  },
  
  summaryLabel: {
    fontSize: 10,
    color: "#444",
  },
  
  summaryValue: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#000",
  },
  introContainer: {
    borderWidth: 1,
    borderColor: "#ddd",
    padding: 12,
    borderRadius: 4,
    marginBottom: 20,
  },
  
  introRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  
  introBlock: {
    width: "48%",
  },
  
  introLabel: {
    fontSize: 10,
    color: "#555",
    marginBottom: 2,
  },
  
  introValue: {
    fontSize: 11,
    fontWeight: "bold",
    marginBottom: 6,
  },
});

const PayrollPDFMonthly = ({ user, records, summary, startOfMonth, endOfMonth }) =>  {
  console.log(records)
  const toNumber = (v) => (isNaN(v) || v === null ? 0 : Number(v));
  const formatMoney = (v) => `£${toNumber(v).toFixed(2)}`;

  // Overtime pay same source as web view: attendanceOvertimes[0]
  const getOvertimePay = (a) => {
    const ot = a?.attendanceOvertimes?.[0];
    if (!ot || ot.status !== "approved") return formatMoney(0);

    if (ot.fixed_overtime_amount != null) {
      return formatMoney(parseFloat(ot.fixed_overtime_amount));
    }
    if (ot.overtime_rate_per_hour != null) {
      const rate = parseFloat(ot.overtime_rate_per_hour);
      const m = /(\d+)\s*h\s*(\d+)?\s*m?/.exec(ot.total_duration || "");
      const hours = m ? parseInt(m[1] || 0) + parseInt(m[2] || 0) / 60 : 0;
      return formatMoney(rate * hours);
    }
    return formatMoney(0);
  };
return(

<Document>
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <View style={styles.header}>
  <Image src="/assets/images/logo.png" style={styles.logo} />
</View>

<View style={styles.introContainer}>
  <View style={styles.introRow}>

    {/* LEFT SIDE - EMPLOYEE INFO */}
    <View style={styles.introBlock}>
      <Text style={styles.introLabel}>Employee Name</Text>
      <Text style={styles.introValue}>{user.name}</Text>

      <Text style={styles.introLabel}>Payroll Type</Text>
      <Text style={styles.introValue}>{user.payroll_type?.toUpperCase()}</Text>

      <Text style={styles.introLabel}>Rate</Text>
      <Text style={styles.introValue}>
        £{user.rate}{" "}
        {user.payroll_type === "hourly"
          ? "/ hour"
          : user.payroll_type === "daily"
          ? "/ day"
          : "/ month"}
      </Text>
    </View>

    {/* RIGHT SIDE - WEEK SUMMARY */}
    <View style={styles.introBlock}>
      <Text style={styles.introLabel}>Payroll Month</Text>
      <Text style={styles.introValue}>
        {startOfMonth.format("DD MMM")} – {endOfMonth.format("DD MMM YYYY")}
      </Text>

      <Text style={styles.introLabel}>Generated On</Text>
      <Text style={styles.introValue}>{moment().format("DD MMM YYYY")}</Text>
    </View>

  </View>
</View>

    

      {/* Table */}
      <View style={styles.table}>
        <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.cellBase, styles.cellDate,{color:'white'}]}>Day & Date</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Punch In</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Punch Out</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Work Hours</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Approved</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Overtime Rate</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Status</Text>
        </View>

        {records.slice(0,20).map((a, i) => (
          <View style={styles.tableRow} key={i} >
            <Text style={[styles.cellBase, styles.cellDate]}>
              {moment(a.attendance_date || a.date).format("ddd, DD MMM")}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.punch_in_time ? moment(a.punch_in_time, "HH:mm:ss").format("hh:mm A") : "--"}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.punch_out_time ? moment(a.punch_out_time, "HH:mm:ss").format("hh:mm A") : "--"}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.total_work_hours || 0}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.approved_hours || 0}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {getOvertimePay(a)}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.status === "on-time" || a.status === "early"
                ? "P"
                : a.status === 'absent' ? 'A' : String(a.status || "N/A").toLowerCase()}
            </Text>
          </View>
        ))}
     
      </View>
      <View style={styles.table} break> 
        <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.cellBase, styles.cellDate,{color:'white'}]}>Day & Date</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Punch In</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Punch Out</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Work Hours</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Approved</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Overtime Rate</Text>
          <Text style={[styles.cellBase, styles.cellSmall,{color:'white'}]}>Status</Text>
        </View>
      {records.slice(20,40).map((a, i) => (
          <View style={styles.tableRow} key={i} >
            <Text style={[styles.cellBase, styles.cellDate]}>
              {moment(a.attendance_date || a.date).format("ddd, DD MMM")}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.punch_in_time ? moment(a.punch_in_time, "HH:mm:ss").format("hh:mm A") : "--"}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.punch_out_time ? moment(a.punch_out_time, "HH:mm:ss").format("hh:mm A") : "--"}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.total_work_hours || 0}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.approved_hours || 0}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {getOvertimePay(a)}
            </Text>
            <Text style={[styles.cellBase, styles.cellSmall]}>
              {a.status === "on-time" || a.status === "early"
                ? "P"
                : a.status === 'absent' ? 'A' : String(a.status || "N/A").toLowerCase()}
            </Text>
          </View>
        ))}
        </View>
      {/* Summary */}
      <View style={styles.summary}>
  
      <View style={styles.summaryRow}>
    <Text style={styles.summaryLabel}>Working Hours <Text style={{fontSize: 8}}>(as per attendance)</Text></Text>
    <Text style={styles.summaryValue}>{summary.total_hours || 0}hr</Text>
  </View>

  <View style={styles.summaryRow}>
    <Text style={styles.summaryLabel}>Overtime </Text>
    <Text style={styles.summaryValue}>{summary.total_overtime || 0}hr</Text>
  </View>

  <View style={styles.summaryRow}>
    <Text style={styles.summaryLabel}>Approved Hours <Text style={{fontSize: 8}}>(as per admin)</Text></Text>
    <Text style={styles.summaryValue}>{summary.approved_hours || 0}hr</Text>
  </View>

  <View style={styles.summaryRow}>
    <Text style={styles.summaryLabel}>Gross</Text>
    <Text style={styles.summaryValue}>{formatMoney(summary?.base_wage)}</Text>
  </View>

  <View style={styles.summaryRow}>
    <Text style={styles.summaryLabel}>Overtime Pay</Text>
    <Text style={styles.summaryValue}>{formatMoney(summary.overtime_wage)}</Text>
  </View>

  <View style={styles.summaryRow}>
    <Text style={styles.summaryLabel}>Deductions</Text>
    <Text style={styles.summaryValue}>{formatMoney(summary?.total_deduction)}</Text>
  </View>
  <View style={styles.summaryRow}>
    <Text style={styles.summaryLabel}>Net</Text>
    <Text style={styles.summaryValue}>{formatMoney(summary.wage)}</Text>
  </View>
</View>
   
      {/* Signatures */}
      <View style={styles.signatureContainer}>
      <View style={styles.line}>
        <View style={{borderTopWidth: 1, borderTopColor: 'black', width: 150,marginBottom: 10}}/>
          <Text>Signature of Employee</Text>
        </View>
        <View style={styles.line}>
        <View style={{borderTopWidth: 1, borderTopColor: 'black', width: 150,marginBottom: 10}}/>
          <Text>Administration Signature</Text>
        </View>
      
      </View>
    </Page>
  </Document>
);
  }

export default PayrollPDFMonthly;
